import { memo } from "react";
import { View, Banner } from "@src/components";
import { MonitoringUpsellBanner } from "./MonitoringUpsellBanner";
import { MonitoringUpgradeDialog } from "./MonitoringUpgradeDialog";
import { MonitoringRequestSentDialog } from "./MonitoringRequestSentDialog";

interface MonitoringBannerSectionProps {
  siteId: string;
  showMonitoring: boolean;
  onUpgrade: () => void;
}

export const MonitoringBannerSection = memo<MonitoringBannerSectionProps>(({ siteId, showMonitoring, onUpgrade }) =>
  showMonitoring ?
    <Banner variant="info" title="Monitoring is active on this site" />
  : <MonitoringUpsellBanner siteId={siteId} onUpgrade={onUpgrade} />,
);

export const SiteWideRecordingFooter = memo(() => (
  <View mt="3xl">
    <Banner variant="info" title="Site-wide recording is always on." />
  </View>
));

interface MonitoringDialogsProps {
  siteId: string;
  showUpgradeModal: boolean;
  setShowUpgradeModal: (v: boolean) => void;
  showRequestSentModal: boolean;
  setShowRequestSentModal: (v: boolean) => void;
  handleUpgradeRequest: () => void;
}

export const MonitoringDialogs = memo<MonitoringDialogsProps>(
  ({
    siteId,
    showUpgradeModal,
    setShowUpgradeModal,
    showRequestSentModal,
    setShowRequestSentModal,
    handleUpgradeRequest,
  }) => (
    <>
      <MonitoringUpgradeDialog
        visible={showUpgradeModal}
        siteId={siteId}
        onClose={() => setShowUpgradeModal(false)}
        onSendRequest={handleUpgradeRequest}
      />
      <MonitoringRequestSentDialog visible={showRequestSentModal} onClose={() => setShowRequestSentModal(false)} />
    </>
  ),
);
